import { Skeleton as ChakraSkeleton } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type SkeletonProps = ComponentPropsWithRef<typeof ChakraSkeleton>;

export function Skeleton(props: SkeletonProps) {
  return <ChakraSkeleton {...props} />;
}
